import React from 'react'
import CartShowcase from '../Components/CartShowcase'
import TopHeader from '../Components/TopHeader';
import MainHeader from '../Components/MainHeader';
import { Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import CardPaymentOption from '../Components/CardPaymentOption';

function PaymentProcess() {
    const location = useLocation()
    const { details, items, price } = location.state;
    const [total, totalPrice, discount] = price;

    return (
        <>
        <TopHeader/>
        <MainHeader />
        <Container className='my-5 d-flex flex-column'>
            <CartShowcase items={items} price={[total, totalPrice, discount]} />
            <CardPaymentOption details={details} price={price} items={items} />
        </Container>
        </>
    )
}

export default PaymentProcess